/**
 * The external dependencies.
 */
import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import styled from 'styled-components';
import * as R from 'ramda';
import {compose, find, pluck, propEq, zipObj} from 'ramda';
/**
 * The internal dependencies.
 */
import FlexRootWrapper from '../../components/general/flex-root';
import Header from '../../components/task/shop/header';
import Text from '../../components/task/shop/text';
import Steps from '../../containers/disponent/steps';
import Actions from '../../containers/disponent/actions';
import QuantityInput from '../../components/task/shop/form/quantity-input';
import StepsInput from '../../components/task/shop/form/steps-input';
import UsersInput from '../../containers/disponent/users-input';
import DepartmentsInput from '../../containers/disponent/departments-input';
import DepartmentsConfigInput from '../../containers/disponent/departmentsConfig-input';
import WorkplaceInput from '../../components/task/shop/form/workplace-input';
import {getAuthUser} from '../../store/auth/selectors';
import {tasksDeselect} from '../../store/tasks/actions';
import {
    getTasksCountForCurrentUsers,
    getTasksCurrent,
    getTaskStepsCount,
    getTaskWorkSteps,
} from '../../store/tasks/selectors';
import {getAllTaskWorkSteps, getWorkstepcount} from "../../store/tasks/selectors";
import {setOverlay, tasksWorkStarted} from "../../store/tasks/actions";
import {disponentnext, freeUser, isDispo, labelconfig, noworkplace} from "../../store/auth/selectors";
import {getDepartmentsConfig, getUsers} from "../../store/dispo/selectors";
import {dispoTaskUpdate} from "../../store/dispo/actions";
import Content from '../../containers/disponent/content';
import Button from '../../components/general/button';
import CustomLabel from "./customLabel";
import {ts_translate} from "../../common/clientTranslate";

const Wrapper = styled(FlexRootWrapper)`
	background: #f8f8f8;
	flex-direction: row;
`;

const InputsWrapper = styled(FlexRootWrapper)`
	padding: 26px 16px 26px 21px;
	border-left: 1px solid #e0e1e1;
`;

const ActionWrapper = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
`;

const TextWrapper = styled.div`
    margin: 10px;
`;

const LabelButtonWrapper = styled.div`
    padding: 26px 0px 0 39px;
    max-width: 300px;
`;

const LabelButton = styled(Button)`
    padding-right: 5px;
    padding-left: 5px;
    min-width: 30px;
    margin-right:5px;
    
    ${({selected}) => selected === true
    ? `
			background: #439DD5;
			color: #fff;

			span {
				border-color: #fff;
			}
		`
    : 'background: #fff'
}
`;

const LabelHeader = styled.div`
    display: block;
    font-size: 20px;
    margin-left: 40px;
    color: #999999;
    font-weight: 600;
    word-break: break-all;
`;

class Form extends React.Component {
    constructor(props) {
        super(props);
        const {departmentsConfig, task, labelconfig} = this.props;
        this.state = {
            currentStep: null,
            isFormCompleted: null,
            inputs: [],
            labels: R.without(R.without(labelconfig, task.labels), task.labels),
            customLabel: R.join('', R.without(labelconfig, task.labels)),
        };

        this.state.inputs.push({
            id: 'quantity',
            label: 'Stückzahl wählen',
            current: false,
            completed: true,
            value: R.clone(this.props.task.quantity),
            component: QuantityInput,
            maxValue: this.props.task.quantity,
            prev: 'none'
        });

        this.state.inputs.push({
                id: 'step',
                label: 'Arbeitsschritt wählen',
                current: null,
                completed: null,
                value: 0,
                component: StepsInput,
                maxValue: this.props.workstepCount,
                prev: 'quantity'
            },
        );

        const {isDispo, freeUser, noworkplace} = this.props;

        if (!noworkplace) {
            this.state.inputs.push({
                id: 'place',
                label: 'Arbeitsplatz wählen',
                current: null,
                completed: null,
                value: '',
                valuePrefix: 'Arbeitsplatz',
                component: WorkplaceInput,
                prev: 'step'
            })
        }

        if (isDispo) {
            if (freeUser) {
                // A free Dispo can select the departments.
                this.state.inputs.push(
                    {
                        id: 'departmentPreselect',
                        label: 'Gespeicherte Abt.',
                        current: null,
                        completed: null,
                        value: [],
                        viewValue: [],
                        valuePrefix: 'Abteilung',
                        component: DepartmentsConfigInput,
                        departmentsConfig: departmentsConfig,
                        prev: ''
                    }
                );
                this.state.inputs.push(
                    {
                        id: 'departmentIds',
                        label: 'Abteilungen wählen',
                        current: null,
                        completed: null,
                        value: [],
                        viewValue: [],
                        valuePrefix: 'Abteilung',
                        component: DepartmentsInput,
                        prev: !noworkplace ? 'place' : 'quantity'
                    }
                );
                this.state.inputs.push(
                    {
                        id: 'userId',
                        label: 'Arbeiter wählen',
                        current: null,
                        completed: null,
                        value: '',
                        viewValue: '',
                        valuePrefix: 'Arbeiter',
                        component: UsersInput,
                        prev: 'departmentIds'
                    }
                )
            } else {
                // A not free Dispo may only select the workers
                this.state.inputs.push(
                    {
                        id: 'userId',
                        label: 'Arbeiter wählen',
                        current: null,
                        completed: null,
                        value: '',
                        viewValue: '',
                        valuePrefix: 'Arbeiter',
                        component: UsersInput,
                        prev: !noworkplace ? 'place' : 'quantity'
                    }
                )
            }
        }
    }

    setCurrentStep = (step) => {
        const {inputs} = this.state;
        const currentlyActive = find(propEq('current', true))(inputs);
        const currentlyClicked = find(propEq('label', step.label))(inputs);

        if (currentlyActive) {
            currentlyActive.current = false;
        }

        const shouldSetToCurrent = !(currentlyActive && currentlyClicked.label === currentlyActive.label);

        currentlyClicked.current = shouldSetToCurrent;

        this.setState({
            currentStep: shouldSetToCurrent
                ? currentlyClicked
                : null,
        });
    };

    setStepAsCompleted = (step) => {
        if (!step.value) {
            return;
        }

        const {inputs} = this.state;
        const {disponentnext} = this.props;

        const currentlyClicked = find(propEq('label', step.label))(inputs);

        currentlyClicked.current = false;
        currentlyClicked.completed = true;

        const quant = R.find(R.propEq('id', 'quantity'))(inputs);

        this.setState({
            currentStep: null,
            isFormCompleted: (inputs.length === inputs.filter(i => i.completed).length) || quant.value > 0,
        });


        const nextStep = find(propEq('prev', step.id))(this.state.inputs);
        if (nextStep && disponentnext) {
            this.setCurrentStep(nextStep);
        }
    };

    updateStepCurrentValue = (value) => {
        // console.log("updateStepCurrentValue", value);
        const currentStep = find(propEq('current', true))(this.state.inputs);
        if (currentStep.viewValue !== undefined) {
            currentStep.value = value.value;
            currentStep.viewValue = value.viewValue;
        } else {
            currentStep.value = value;
        }
        this.setState({currentStep});
    };

    updateStepCurrentValueMulti = (value) => {

        const currentStep = find(propEq('current', true))(this.state.inputs);
        if (value.selected) {
            currentStep.value.push(value.id);
            currentStep.value = R.uniq(currentStep.value);
            currentStep.viewValue.push(value.name);
            currentStep.viewValue = R.uniq(currentStep.viewValue);
        } else {
            const isNotId = n => n !== value.id;
            const isNotName = n => n !== value.name;
            currentStep.value = R.filter(isNotId, currentStep.value);
            currentStep.viewValue = R.filter(isNotName, currentStep.viewValue);
        }
        this.setState({currentStep});
    };


    getInputsValues() {
        const {inputs} = this.state;
        return zipObj(pluck('id', inputs), pluck('value', inputs));
    }

    setCustomLabel = ({target: {value}}) => this.setState({customLabel: value});

    setLabel(label) {
        const {labels} = this.state;
        let newLabels = [];
        if (R.includes(label, labels)) {
            newLabels = R.without(label, labels);
        } else {
            newLabels = R.append(label, labels);
        }
        this.setState({labels: newLabels});
    }

    reserve = (submit = null) => {
        const {
            task,
            dispoTaskUpdate,
            tasksDeselect,
            user,
            setOverlay
        } = this.props;

        const {labels, customLabel} = this.state;
        let cLabels = R.clone(labels);
        if (customLabel !== '') {
            cLabels = R.append(customLabel, labels);
        }
        const data = {
            ...this.getInputsValues(),
            id: `${task.id}`,
            labels: cLabels
        };

        if (data.userId !== '') {
            data.status = 'reserved';
        }

        if (R.isEmpty(data.departmentIds) && !R.isEmpty(data.departmentPreselect)) {
            data.departmentIds = data.departmentPreselect;
        }

        if (data.departmentPreselect) delete data.departmentPreselect;
        dispoTaskUpdate(task.id, data, user);
        tasksDeselect();
    };

    render() {
        const {
            currentStep,
            isFormCompleted,
            inputs,
            labels,
            customLabel,
        } = this.state;
        const {materials, taskImage, taskStep, freeUser, task, allWorkSteps, labelconfig} = this.props;
        const viewValues = freeUser ? find(propEq('id', 'departmentIds'))(inputs).viewValue : task.departmentIds;
        const InputComponent = currentStep ? currentStep.component : null;
        let stepName = '';

        if (R.find(R.propEq('selectionorder', task.step))(allWorkSteps) !== undefined) {
            let step = R.find(R.propEq('selectionorder', task.step))(allWorkSteps);
            stepName = step.label + ' ' + step.name;
        }

        return (
            <Wrapper>
                <FlexRootWrapper>
                    <Header color="#d9d7d7"></Header>

                    <Steps steps={inputs} handleSelect={this.setCurrentStep}/>

                    <LabelHeader>{ts_translate('Labels')}:</LabelHeader>
                    {labelconfig && R.length(labelconfig) > 0 && <LabelButtonWrapper>
                        {labelconfig.map((label, index) =>
                            <LabelButton
                                onClick={() => this.setLabel(label)}
                                selected={R.includes(label, labels)}
                                key={index}
                            >
                                {label}
                            </LabelButton>)}
                    </LabelButtonWrapper>}

                    <LabelButtonWrapper>
                        <CustomLabel handleChange={this.setCustomLabel} value={customLabel}></CustomLabel>
                    </LabelButtonWrapper>

                    <ActionWrapper>
                        <Actions
                            disabled={!isFormCompleted || currentStep !== null}
                            reserve={this.reserve}
                        />
                    </ActionWrapper>
                </FlexRootWrapper>

                {currentStep && (
                    <FlexRootWrapper>
                        <Header color="#d9d7d7" textColor="#707070;">
                            <Text flex>
                                {currentStep.label}
                            </Text>
                        </Header>

                        <InputsWrapper>
                            {currentStep.id === 'departmentIds' ?
                                <InputComponent
                                    data={currentStep}
                                    handleSelect={this.updateStepCurrentValueMulti}
                                    handleComplete={this.setStepAsCompleted}
                                />
                                : <InputComponent
                                    data={currentStep}
                                    handleSelect={this.updateStepCurrentValue}
                                    handleComplete={this.setStepAsCompleted}
                                    departmentViewValue={viewValues}
                                />}
                        </InputsWrapper>
                    </FlexRootWrapper>
                )}
                {!currentStep && (
                    <FlexRootWrapper>
                        <Header color="#d9d7d7">
                            <Text flex>
                                Anleitung:
                            </Text>
                        </Header>
                        <TextWrapper>

                            <Content
                                stepNumber={stepName}
                                materials={materials}
                            />

                        </TextWrapper>
                    </FlexRootWrapper>
                )}

            </Wrapper>
        );
    }
}

export default compose(
    connect(
        (state) => ({
            workSteps: getTaskWorkSteps(state),
            task: getTasksCurrent(state),
            steps: getTaskStepsCount(state),
            user: getAuthUser(state),
            tasksForUserCount: getTasksCountForCurrentUsers(state),
            workstepCount: getWorkstepcount(state),
            isDispo: isDispo(state),
            freeUser: freeUser(state),
            users: getUsers(state),
            noworkplace: noworkplace(state),
            disponentnext: disponentnext(state),
            allWorkSteps: getAllTaskWorkSteps(state),
            departmentsConfig: getDepartmentsConfig(state),
            labelconfig: labelconfig(state),
        }), {
            dispoTaskUpdate,
            tasksDeselect,
            setOverlay,
            tasksWorkStarted,
        }
    ),
    withRouter
)(Form);



// WEBPACK FOOTER //
// ./src/containers/disponent/form.js